import { employeeTableData } from "../../constants/table";
import Slide from "react-reveal/Slide";
import { IoAddCircle } from "react-icons/io5";
import { useContext, useState } from "react";
import Addemployee from "./addemployee";
import { GrNext, GrPrevious } from "react-icons/gr";
import useEmployeeController from "../../controllers/useEmployeeController";
import Account from "../../context/acount";
import { permission_type } from "../../constants";
import { useNavigate } from "react-router-dom";
export default function EmployeeTable() {
  const [add, setAdd] = useState(false);
  const { control } = useContext(Account);
  const {
    list,
    loading,
    account,
    permission,
    handleChange,
    handleChangePermission,
    create,
  } = useEmployeeController(control[permission_type.VIEW_EMPLOYEE_LIST]);
  const navigate=useNavigate();
  const thstyle = "text-gray-500 font-Roboto text-sm font-bold tracking-wider ";
  if (!add)
    return (
      <div className="mt-4 p-4 bg-white shadow-lg  w-[90%] m-auto rounded-md ">
        <div className="flex  bg-[#3399ef] h-[80px] rounded-md font-Roboto font-bold text-white m-auto  pl-4 pt-5 bg-gradient-to-r from-cyan-500 to-cyan-600">
          Employee Table
        {control && control[permission_type.CREATE_EMPLOYEE] &&  <IoAddCircle
            className="scale-125  ml-5 cursor-pointer hover:scale-150"
            onClick={() => setAdd(true)}
          />}
        </div>
        <table className=" w-[80%] m-auto mt-4">
          <tr>
            <td className={thstyle}>Name</td>
            <td className={thstyle}>Account Type</td>
            <td className={thstyle}>verified</td>
            <td></td>
          </tr>
          {list.map((el) => {
            return (
              <Slide top  key={el._id}>
              <tr
                className="border-b-[1px] border-gray-400 hover:shadow-2xl"
               
              >
                
                  <td>
                    <div className="flex space-x-1 p-1">
                      <img
                        src={el.profileurl}
                        alt="profile"
                        className="w-10 h-10 rounded-lg"
                      />
                      <div className="flex flex-col space-y-1 font-Roboto  text-sm  tracking-wider">
                        <p className="font-bold text-gray-700">
                          {(el.firstname || '') + " " + (el.lastname || '')}
                        </p>
                        <p className="text-gray-500">{el.email}</p>
                      </div>
                    </div>
                  </td>
                  <td className="font-Roboto text-sm">{el.accountType}</td>
                  <td
                    className={`font-Roboto text-sm ${
                      el.verified ? "text-green-600" : "text-red-600"
                    }`}
                  >
                    {el.verified ? "True" : "False"}
                  </td>
                  {control && control[permission_type.VIEW_EMPLOYEE] && (
                    <td
                      className="font-Roboto text-sm text-gray-400 cursor-pointer hover:text-gray-950"
                      onClick={() =>
                        navigate(
                          `/dashboard/account?_id=${el._id}&type=${el.accountType}`
                        )
                      }
                    >
                      view
                    </td>
                  )}
                
              </tr>
              </Slide>
            );
          })}
        </table>
        {/*<div className="flex space-x-2 mb-2 ">
        <GrPrevious className="cursor-pointer hover:scale-150" />
        <p className="-translate-y-1 font-Roboto text-sm text-gray-600">page 1</p>
        <GrNext  className="cursor-pointer hover:scale-150"/>
        
        </div> */}
      </div>
    );
  else
    return (
      <Slide bottom>
        <Addemployee
          setOpen={setAdd}
          loading={loading}
          account={account}
          permission={permission}
          handleChange={handleChange}
          handleChangePermission={handleChangePermission}
          create={create}
        />
      </Slide>
    );
}
